import { AppBar } from '@mui/material';

import styles from './styles';

export default function Navbar({ children }: { children: React.ReactNode }) {
  return <AppBar sx={styles.navbar}>{children}</AppBar>;
}
